
export default {
  name: 'HappyKidsFeaturedCard',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
    dataKey: {
      type: String,
      default: null,
    },
    dataLength: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      isActive: true,
    }
  },
  
  computed: {
    verifiedImg() {
      return require("~/assets/images/family/icon/tenlife-verified.png")
    }
  },
}
